// extracted by mini-css-extract-plugin
export default {"container":"avatar_container__3upTf","small":"avatar_small__Ks87J","square":"avatar_square__1-tzy","inverted":"avatar_inverted__8ERTK","letter":"avatar_letter__MrS53"};